<template>
  <PageWrapper :handleBack="goToCenterExecuteList">
    <Tabs :tabs="tabs" tabContentClass="overflow-y-hidden">
      <template #tab-0>
        <GeneralInformation @handleReload="fetchData" />
      </template>
      <template #tab-1>
        <PersonsList />
      </template>
      <template #tab-2>
        <CenterExecuteAttachments />
      </template>
      <template #tab-3>
        <RoomsList />
      </template>
      <template #tab-4>
        <Alert
          :text="$lang.virtualCenterExecuteAlertMessage"
          variant="light-warning"
          class="margin-bottom-12"
        />
        <Activities
          resourceName="center_execute"
          :resourceValue="centerExecuteId"
          :termCode="termCode"
          :termId="termId"
          :isReadonly="isReadonly"
        />
      </template>
      <template #tab-5>
        <Alert
          :text="$lang.virtualCenterExecuteAlertMessage"
          variant="light-warning"
          class="margin-bottom-12"
        />
        <ExercisePrerequisiteList />
      </template>
    </Tabs>
  </PageWrapper>
</template>

<script>
import { PageWrapper, Tabs, Activities, Alert } from "@/components/re-design";
import GeneralInformation from "./GeneralInformation.vue";
import PersonsList from "./persons/PersonsList.vue";
import RoomsList from "./rooms/RoomsList.vue";
import ExercisePrerequisiteList from "./exercise-prerequisite/ExercisePrerequisiteList.vue";
import CenterExecuteAttachments from "./attachments/CenterExecuteAttachments.vue";
import {
  generateCurrentRoute,
  generateError,
  generateLang,
  goToRoute,
  storeDispatcher,
} from "@/shared/utils";
import { computed, onMounted, provide, ref } from "vue";
import { pathOr } from "ramda";
import { getCenterExecuteV1 } from "@/modules/kanoon/services";

export default {
  components: {
    PageWrapper,
    Tabs,
    Activities,
    GeneralInformation,
    PersonsList,
    RoomsList,
    ExercisePrerequisiteList,
    CenterExecuteAttachments,
    Alert,
  },
  setup() {
    const centerExecuteId = generateCurrentRoute(["params", "centerExecuteId"]);

    const setMobileHeaderTitle = () => {
      const { title } = centerExecuteData.value;
      const headerTitle = `${generateLang([
        "centerExecuteEdit",
      ])} <span class="margin-right-4">${title}</span>`;
      storeDispatcher("mobileHeaderTitleText", headerTitle);
    };

    const permissions = ref([]);
    const centerExecuteData = ref(null);
    const loading = ref(false);
    const fetchData = async () => {
      try {
        loading.value = true;
        const response = await getCenterExecuteV1(centerExecuteId);
        const { getData, getPermissions } = response;
        centerExecuteData.value = getData;
        permissions.value = getPermissions;
        setMobileHeaderTitle();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => fetchData());

    const tabs = computed(() => {
      const hasData = !!centerExecuteData.value;
      const isVirtualType =
        pathOr(null, ["centerExecuteType", "id"], centerExecuteData.value) ===
        1;

      const tabList = [
        {
          show: true,
          text: "اطلاعات کلی",
        },
        { show: hasData, text: "افراد" },
        { show: hasData, text: "پیوست ها" },
        { show: hasData, text: "اتاق ها" },
        {
          show: hasData && isVirtualType,
          text: "فعالیت ها",
        },
        {
          show: hasData && isVirtualType,
          text: "پیش نیاز تمرین ها",
        },
      ];

      return tabList;
    });

    const termCode = computed(() =>
      pathOr(null, ["term", "id"], centerExecuteData.value)
    );
    const termId = computed(() =>
      pathOr(null, ["term", "termId"], centerExecuteData.value)
    );

    const goToCenterExecuteList = () => {
      const centerExecuteListBackRoute = computed(() =>
        localStorage.getItem("centerExecuteListBackRoute")
      );
      goToRoute(centerExecuteListBackRoute.value, {}, {}, false);
    };

    const isReadonly = computed(
      () => pathOr(null, ["status", "id"], centerExecuteData.value) !== 1
    );

    // provide data
    provide(
      "GET_LOADING",
      computed(() => loading.value)
    );
    provide(
      "CENTER_EXECUTE_DATA",
      computed(() => centerExecuteData.value)
    );
    provide(
      "PERMISSIONS",
      computed(() => permissions.value)
    );
    provide(
      "IS_READONLY",
      computed(() => isReadonly.value)
    );

    // return data to be used in template
    return {
      tabs,
      centerExecuteData,
      centerExecuteId,
      termCode,
      termId,
      isReadonly,
      goToCenterExecuteList,
      fetchData,
    };
  },
};
</script>
